import type { ThreeDsRuleExecuteRequest, ThreeDsRuleResponse } from '../types';
import type { RequestFn } from '../client';

export class ThreeDsRules {
  constructor(private readonly request: RequestFn) {}

  async execute(params: ThreeDsRuleExecuteRequest): Promise<ThreeDsRuleResponse> {
    return this.request('POST', '/three-ds-decision/execute', { body: params });
  }
}
